import React, { useEffect, useState, useRef } from 'react';
import HeroSection from './HeroSection';
import ProblemSection from './ProblemSection';
import SolutionSection from './SolutionSection';
import ProductSection from './ProductSection';
import TestimonialsSection from './TestimonialsSection';
import ProcessSection from './ProcessSection';
import BreakdownSection from './BreakdownSection';
import UrgencySection from './UrgencySection';
import PromisesSection from './PromisesSection';
import FaqSection from './FaqSection';

const SimpleLandingPage = () => {
  return (
    <>
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <ProductSection />
      <TestimonialsSection />
      <ProcessSection />
      <BreakdownSection />
      <UrgencySection />
      <PromisesSection />
      <FaqSection />
    </>
  );
};

export default SimpleLandingPage;